"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMembershipStatus = void 0;
var UserMembershipStatus;
(function (UserMembershipStatus) {
    UserMembershipStatus["None"] = "none";
    UserMembershipStatus["Trail"] = "trail";
    UserMembershipStatus["Churned"] = "churned";
    UserMembershipStatus["Paying"] = "paying";
    UserMembershipStatus["Free"] = "free";
    UserMembershipStatus["Undefined"] = "undefined";
})(UserMembershipStatus = exports.UserMembershipStatus || (exports.UserMembershipStatus = {}));
//# sourceMappingURL=userProperties.js.map